/* eslint-disable @typescript-eslint/no-explicit-any */
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm, type Control, type FieldErrors, type UseFormRegister } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/Button';

import { PortsEditor } from '../components/PortsEditor';
import { step2Schema, type Step2Values } from '../schemas';
import { useSparkStore } from '../store';
import { WizardFooter } from './Step1Basic';

export function Step2Inputs({
  onAdvance,
  onBack,
}: {
  onAdvance: () => void;
  onBack: () => void;
}) {
  const { t } = useTranslation('spark');
  const input_ports = useSparkStore((s) => s.input_ports);

  const form = useForm<Step2Values>({
    resolver: zodResolver(step2Schema),
    mode: 'onBlur',
    defaultValues: { inputs: input_ports },
  });

  const onSubmit = (v: Step2Values) => {
    useSparkStore.getState().applyStep2(v);
    onAdvance();
  };

  return (
    <form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-col gap-5" noValidate>
      <p className="text-sm text-ink-muted">{t('steps.2.intro')}</p>

      <PortsEditor
        control={form.control as unknown as Control<any>}
        register={form.register as unknown as UseFormRegister<any>}
        errors={form.formState.errors as FieldErrors<any>}
        name="inputs"
      />

      <WizardFooter onBack={onBack}>
        <Button type="submit" variant="primary">
          {t('actions.next', { ns: 'common' })}
        </Button>
      </WizardFooter>
    </form>
  );
}
